import { flexRender } from "@tanstack/react-table";
import React from "react";
import { useTheme } from "styled-components";
import { horizontalListSortingStrategy, SortableContext } from "@dnd-kit/sortable";
import { Box } from "../../Box";
import { HeaderCellWrapper } from "./HeaderCellWrapper";
/**
 * Helper component that renders the header and all header cells using default rendering
 */
export const SimpleHeader = ({ enableDnD, table, "data-testid": dataTestId, }) => {
    const { colors: { tableColors }, } = useTheme();
    const { columnOrder } = table.getState();
    return (React.createElement(Box, { as: "thead", "data-testid": dataTestId }, table.getHeaderGroups().map((headerGroup) => (React.createElement(Box, { as: "tr", "data-testid": "headerRow", key: headerGroup.id, backgroundColor: tableColors.tableRowHeader },
        React.createElement(SortableContext, { items: columnOrder, strategy: horizontalListSortingStrategy }, headerGroup.headers.map((header) => (React.createElement(HeaderCellWrapper, { key: header.id, enableDnD: enableDnD, header: header }, header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext()))))))))));
};
